// Centralised UI copy for the move-with-automation modal and its
// supporting helpers. Follows the project's `[feature].strings.ts`
// convention (see `quickAppReview.strings.ts`) — static text as
// constants, dynamic text as small format functions so consumers
// pass values in instead of concatenating in-place.

export const MOVE_WITH_AUTOMATION_STRINGS = {
  modal: {
    title: 'Move to stage with automation?',
    body: 'You can decide to run automations or skip them for this candidate',
    automationSectionLabel: 'Automation',
    closeAriaLabel: 'Close',
  },
  currentStage: {
    allCanceled: 'All existing automations in current stage will be canceled.',
  },
  cta: {
    cancel: 'Cancel',
    moveWithoutAutomation: 'Move without automation',
    move: 'Move',
  },
  fallback: {
    stageName: 'Stage',
    activityLabel: 'Activity',
    previousActivity: 'previous activity',
  },
  timing: {
    immediately: 'Immediately',
    immediatelyAfter: (prevLabel: string) => `Immediately after ${prevLabel}`,
    afterStageEntry: (duration: string) => `${duration} after stage entry`,
    afterPrevious: (duration: string, prevLabel: string) =>
      `${duration} after ${prevLabel}`,
    // Reviewers submitting their scorecards on the previous activity.
    afterScorecardsSubmitted: (prevLabel: string) =>
      `After all ${prevLabel} scorecards are submitted`,
    afterSent: (prevLabel: string) => `After ${prevLabel} is sent`,
    // Interview triggers.
    afterScheduled: (prevLabel: string) => `After ${prevLabel} is scheduled`,
    // Candidate finishing the previous activity (and legacy "submitted") plus
    // interview "completed" all read as the activity being completed.
    afterCompleted: (prevLabel: string) => `After ${prevLabel} is completed`,
  },
  duration: {
    days: (n: number) => `${n} ${n === 1 ? 'day' : 'days'}`,
    hours: (n: number) => `${n} ${n === 1 ? 'hour' : 'hours'}`,
    minutes: (n: number) => `${n} ${n === 1 ? 'minute' : 'minutes'}`,
  },
  stopWarning: {
    text: (n: number) =>
      `Active automation for ${n} ${n === 1 ? 'candidate' : 'candidates'} will be stopped`,
    // Split parts so only the count (between prefix and suffix) is rendered as
    // the clickable trigger that opens the candidates modal.
    prefix: 'Active automation for',
    suffix: (n: number) =>
      `${n === 1 ? 'candidate' : 'candidates'} will be stopped`,
  },
  // Modal opened from the close-job warning, listing the candidates whose
  // active automations will be cancelled.
  stopCandidatesModal: {
    header: (n: number) =>
      `Active automation for ${n} ${n === 1 ? 'candidate' : 'candidates'}`,
    columns: {
      candidate: 'Name',
      stage: 'Stage',
      activity: 'Activity',
    },
    empty: 'No active automations found.',
  },
} as const;
